import Head from 'next/head';

export default function ImgPreLoadA() {
    return (
        <>
            <Head>
                <link rel="preload" as="image" href="https://websiteoss.ecoflow.com/upload/image/1747228999696/kv-m.jpg" />
            </Head>
        </>
    );
}
